import React, { useContext, useEffect, useState } from "react";
import { UserDto } from "../../../../dtos/catalogs/User/UserDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import { ActivitiesDto } from "../../../../dtos/catalogs/User/ActivitiesDto";
import UserDetailSkeleton from "./UserDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import UserDetailMain from "./UserDetailMain";

interface IProps {
  model: UserDto | null;
  modelUpdatedEvent: (newModel: UserDto) => void;
}

interface UserModel {
  id: string;
  userName: string;
  email: string;
  personId?: string;
  userSetting: {
    userId?: string;
    phone: string;
    currentLocale: string;
    timezone: string;
    verificationType: number;
    positionId: string;
    defaultCurrencyId?: string;
    defaultCompanyId?: string;
    defaultWarehouseId?: string;
    defaultDepartmentId?: string;
    defaultIncomeItemId?: string;
    defaultExpenseItemId?: string;
  };
  userSettingId: string;
  applicationUser: {
    id: string;
  };
  applicationUserId: string;
  activities: ActivitiesDto[];
}

export const UserDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<UserModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("userName", model.userName);
      setValue("email", model.email);
      setValue("personId", model.personId);
      // setValue("userSettingId", model.userSettingId);
      setValue("userSetting.userId", model.userSetting?.userId);
      setValue("userSetting.phone", model.userSetting?.phone);
      setValue("userSetting.currentLocale", model.userSetting?.currentLocale);
      setValue("userSetting.timezone", model.userSetting?.timezone);
      setValue("userSetting.verificationType", model.userSetting?.verificationType);
      setValue("userSetting.positionId", model.userSetting?.positionId);
      setValue("userSetting.defaultCurrencyId", model.userSetting?.defaultCurrencyId);
      setValue("userSetting.defaultCompanyId", model.userSetting?.defaultCompanyId);
      setValue("userSetting.defaultWarehouseId", model.userSetting?.defaultWarehouseId);
      setValue("userSetting.defaultDepartmentId", model.userSetting?.defaultDepartmentId);
      setValue("userSetting.defaultIncomeItemId", model.userSetting?.defaultIncomeItemId);
      setValue("userSetting.defaultExpenseItemId", model.userSetting?.defaultExpenseItemId);
      setValue("applicationUserId", model.applicationUserId);
      // setValue("applicationUser.id", model.applicationUser?.id);
      setValue("activities", model.activities);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: UserModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      //@ts-ignore
      const newModel: UserDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <UserDetailSkeleton />
      </>
    );
  }

  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };
  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
          <NFTab title={"Settings"} />
        </NFTabs>

        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />

        <NFTabContainer index={0} currentIndex={tabIndex}>
         <UserDetailMain/>
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
